import React from "react";
import CounterUpCom from "../Helpers/CounterUpCom";

function FunFact() {

  const counterDuration = 3;

  return (
    <div className="counter-area pt-80 pb-80">
      <div className="container">
        <div className="counter-inner wow fadeInUp" data-wow-delay=".1s">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="counter-item">
                <div className="counter-icon">
                  <img
                    src={
                      require(`../../assets/img/icon/counter_icon01.svg`)
                        .default
                    }
                    alt=""
                  />
                </div>
                <div className="counter-content">
                  <span className="count odometer">
                    <CounterUpCom endValue={500} duration={counterDuration} />
                  </span>
                  <p>Products Available</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="counter-item">
                <div className="counter-icon">
                  <img
                    src={
                      require(`../../assets/img/icon/counter_icon02.svg`)
                        .default
                    }
                    alt=""
                  />
                </div>
                <div className="counter-content">
                  <span className="count odometer">
                    <CounterUpCom endValue={100} duration={counterDuration} />
                  </span>
                  <p>Satisfied Clients</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="counter-item">
                <div className="counter-icon">
                  <img
                    src={
                      require(`../../assets/img/icon/counter_icon03.svg`)
                        .default
                    }
                    alt=""
                  />
                </div>
                <div className="counter-content">
                  <span className="count odometer">
                    <CounterUpCom endValue={450} duration={counterDuration} />
                  </span>
                  <p>Experienced Staff</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="counter-item">
                <div className="counter-icon">
                  <img
                    src={
                      require(`../../assets/img/icon/counter_icon04.svg`)
                        .default
                    }
                    alt=""
                  />
                </div>
                <div className="counter-content">
                  <span className="count odometer">
                    <CounterUpCom endValue={10} duration={counterDuration} />
                  </span>
                  <p>Government Recognition/Awards</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FunFact;
